import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy, ArrowLeft } from 'lucide-react';
import { SEO } from '../components/SEO';

function LoginPage() {
  const navigate = useNavigate();

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex">
      <SEO
        title="Sign In"
        description="Sign in to Malda Turf to book cricket and football turf slots online."
        path="/login"
        noindex
      />
      {/* Left Panel */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: 'url(https://images.pexels.com/photos/18717024/pexels-photo-18717024.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)' }} />
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
            <Trophy className="h-6 w-6 text-[#16A34A]" />
            <div>
              <span className="text-lg font-bold font-heading">Malda Turf</span>
              <p className="text-[10px] text-neutral-500 tracking-wider uppercase font-body">Premium Sports Booking</p>
            </div>
          </div>
          <div>
            <h2 className="text-4xl font-bold leading-tight mb-4 font-heading">Your Game.<br /><span className="text-[#16A34A]">Your Time.</span></h2>
            <p className="text-neutral-400 max-w-sm leading-relaxed font-body">Professional cricket and football turfs with flexible hourly booking and instant confirmation.</p>
          </div>
          <p className="text-xs text-neutral-600 font-body">Open 24 Hours, 7 Days a Week</p>
        </div>
      </div>

      {/* Right Panel */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-3 mb-12">
            <Trophy className="h-6 w-6 text-[#16A34A]" />
            <div>
              <span className="text-lg font-bold font-heading">Malda Turf</span>
              <p className="text-[10px] text-neutral-500 tracking-wider uppercase font-body">Premium Sports Booking</p>
            </div>
          </div>

          <div className="mb-10">
            <h1 className="text-3xl font-bold mb-2 font-heading">Sign In</h1>
            <p className="text-sm text-neutral-500 font-body">Book your game time in seconds</p>
          </div>

          <button
            onClick={handleGoogleLogin}
            data-testid="google-login-button"
            className="w-full bg-white text-gray-800 font-semibold py-3.5 px-4 flex items-center justify-center gap-3 hover:bg-gray-100 transition-colors rounded-xl font-heading"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </button>

          <div className="h-[1px] bg-[#262626] my-8"></div>

          <div className="space-y-4">
            {['Flexible hourly booking', 'Instant confirmation', 'Secure payments'].map(t => (
              <div key={t} className="flex items-center gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-[#16A34A]"></div>
                <span className="text-sm text-neutral-500 font-body">{t}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 flex items-center justify-between">
            <button onClick={() => navigate('/')} data-testid="back-to-home-button" className="text-sm text-neutral-500 hover:text-white transition-colors flex items-center gap-1.5 font-body">
              <ArrowLeft className="h-3.5 w-3.5" /> Back to Home
            </button>
            <button onClick={() => navigate('/terms')} className="text-xs text-neutral-600 hover:text-neutral-400 transition-colors font-body">Terms & Conditions</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
